document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    const targetMediaContainer = document.querySelector(
      '.jdgm-widget-actions-wrapper',
    );
    const rowMedia = document.querySelector('div.jdgm-row-media'); // Select the media gallery

    const addReviewBtn = document.querySelector('.jdgm-widget-actions-wrapper'); // select add review button
    const titleContainer = document.querySelector('.jdgm-rev-widg__header'); // select review title parent div

    const reviewHistogram = document.querySelector(
      '.jdgm-histogram.jdgm-temp-hidden',
    ); // Select the Judge.me histogram

    const averageRating = document.querySelector(
      '.jdgm-custom-forms-avg-responses',
    ); // Select the Judge.me average rating container

    const reviewvotes = document.querySelectorAll('div.jdgm-rev__votes'); // select the review vote container
    const targetContainer = document.querySelector('.jdgm-rev-widg__summary'); // Select the target container
    const mainTargetedContainer = document.querySelector('.jdgm-row-stars');

    const purchaseLabel = document.querySelectorAll(
      '.Avada-Subscription__Label',
    );

    // place the review start with progressbar
    if (reviewHistogram && targetContainer) {
      targetContainer.appendChild(reviewHistogram); // Move the histogram inside the target container
      reviewHistogram.classList.remove('jdgm-temp-hidden'); // Make it visible
    }

    // place the media gallery to the targed container
    if (rowMedia && targetContainer) {
      targetContainer.appendChild(rowMedia);
      // rowMedia.classList
    }

    // PLACE THE AVERAGE ANS TO THE MIDDLE OF TARGETED CONTAINER
    if (averageRating && targetContainer) {
      targetContainer.appendChild(averageRating);
    }

    // place add review button to head
    if (addReviewBtn && titleContainer) {
      titleContainer.appendChild(addReviewBtn);
    }

    // add text to review vote container
    if (reviewvotes) {
      reviewvotes.forEach((votes) => {
        const textElement = document.createElement('h2');
        textElement.innerHTML = 'Was this review helpful?';
        textElement.classList.add('review-vote-custom-text');

        const votesInner = votes.querySelector('.jdgm-rev__votes-inner');

        if (votesInner) {
          // Insert textElement right after jdgm-rev__votes-inner
          votesInner.insertAdjacentElement('afterend', textElement);
        } else {
          // If jdgm-rev__votes-inner doesn't exist, append textElement normally
          votes.appendChild(textElement);
        }
      });
    }
  }, 2000); // Delay to allow Judge.me to load
});
